import { LocalStorageKeys } from "hooks/useLocalStorage";
import {jwtDecode} from "jwt-decode";

export const decodeJWT = () => {
  const user = localStorage.getItem(LocalStorageKeys.user);
  if (user) {
    const parsedUser = JSON.parse(user);
    return parsedUser ? jwtDecode(parsedUser?.accessToken) : null;
  }
  return null;
};

export const getRole = () => {
  const token = decodeJWT();
  return token ? token?.role : "";
};
